module.exports = __webpack_public_path__ + "static/media/image-08-full.c1542bb2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/examples/image-08-full.jpg
// module id = 349
// module chunks = 0